export default "__VITE_ASSET__BV3cE_YX__"